import Rest from '../Rest'

export default class RequestBondTypeService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/request_bond_type'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
